import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
    logErrors: true,
  });

  public handleError(error: Error) {
    console.error('[AppErrorHandler] Pulse global error', error);

    this.sentryErrorHandler.handleError(error);
  }
}
